import styled from 'styled-components';
import { Layout } from 'antd';

export const Container = styled(Layout)`
	min-height: 100vh;
`;
